import { createElement } from "@/utils/create-elem.js";
/**
 * Creates a select dropdown with options.
 * @param {Object} params - The parameters for creating the select element.
 * @param {string} params.text
 * @param {string[]} params.classes - Optional array of CSS class names.
 * @param {HTMLElement=} params.parent - Optional parent element to append the select.
 * @param {Function} onClick
 * @returns {HTMLSelectElement} - The created select element.
 */
export function btn(params) {
  const { text, parent, classes = [], onClick } = params;
  const elem = createElement({
    text: text,
    tag: "div",
    parent: parent,
    classes: classes,
  });
  elem.addEventListener("click", onClick);
  return elem;
}
